import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createStaticVNode as _createStaticVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0ca3c4a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  id: "fieldDataHeader",
  class: "grid-table-cell noselect align-middle bg-color-1"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "center-block text-center" }
const _hoisted_4 = { class: "row flex-nowrap" }
const _hoisted_5 = { class: "col-6 p-0" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-map" }, null, -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Map View")
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { class: "col-6 p-0" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-images" }, null, -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Photo View ")
const _hoisted_12 = { class: "position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger" }
const _hoisted_13 = { class: "row flex-nowrap" }
const _hoisted_14 = { class: "col-6 p-0" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-file" }, null, -1))
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Fact Sheet")
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = { class: "col-6 p-0" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-home" }, null, -1))
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Sale History")
const _hoisted_21 = [
  _hoisted_19,
  _hoisted_20
]
const _hoisted_22 = {
  key: 1,
  id: "transferDataHeader",
  class: "grid-table-cell noselect transfer-header"
}
const _hoisted_23 = { class: "container" }
const _hoisted_24 = { class: "row flex-nowrap" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-auto p-0" }, null, -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col p-0 ellipsis" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Transfer to Form")
], -1))
const _hoisted_27 = { class: "col-auto p-0" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "body italic" }, "This data will be transferred to the Comparable Grid when you Save and Close.", -1))
const _hoisted_30 = { class: "footer" }
const _hoisted_31 = { class: "right" }
const _hoisted_32 = {
  key: 2,
  id: "preferencesHeader",
  class: "grid-table-cell noselect bg-color-1"
}
const _hoisted_33 = /*#__PURE__*/_createStaticVNode("<div class=\"container\" data-v-0ca3c4a2><div class=\"row flex-nowrap\" data-v-0ca3c4a2><div class=\"col-auto p-0\" data-v-0ca3c4a2></div><div class=\"col p-0 ellipsis\" data-v-0ca3c4a2><span class=\"title\" data-v-0ca3c4a2>Data Preference Settings</span></div><div class=\"col-auto p-0\" data-v-0ca3c4a2></div></div></div><div class=\"body italic\" data-v-0ca3c4a2>Click any row to change your Data Preference Settings and create/edit Formatting Rules.</div>", 2)
const _hoisted_35 = { class: "footer" }
const _hoisted_36 = { class: "container" }
const _hoisted_37 = { class: "row flex-nowrap" }
const _hoisted_38 = { class: "col-auto p-0" }
const _hoisted_39 = { class: "col-sm-auto initial-badge-container header-badge" }
const _hoisted_40 = { class: "col p-0 ellipsis" }
const _hoisted_41 = { class: "title" }
const _hoisted_42 = {
  key: 0,
  class: "title-sub ms-1"
}
const _hoisted_43 = { class: "col-auto p-0" }
const _hoisted_44 = { key: 0 }
const _hoisted_45 = { class: "p-color-1 hover" }
const _hoisted_46 = /*#__PURE__*/_createTextVNode("Show ")
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-angle-double-right" }, null, -1))
const _hoisted_48 = [
  _hoisted_46,
  _hoisted_47
]
const _hoisted_49 = {
  key: 0,
  class: "body"
}
const _hoisted_50 = {
  key: 0,
  class: "italic version-found"
}
const _hoisted_51 = { key: 0 }
const _hoisted_52 = { key: 1 }
const _hoisted_53 = {
  key: 1,
  class: "container p-0"
}
const _hoisted_54 = { class: "row flex-nowrap m-0" }
const _hoisted_55 = { class: "col-7 p-0" }
const _hoisted_56 = {
  key: 0,
  class: "d-inline your-count me-1"
}
const _hoisted_57 = {
  key: 1,
  class: "d-inline your-peer"
}
const _hoisted_58 = { key: 2 }
const _hoisted_59 = { class: "col-5 p-0" }
const _hoisted_60 = { class: "used-in-report found text-end text-nowrap pe-1" }
const _hoisted_61 = { class: "footer" }
const _hoisted_62 = {
  key: 0,
  class: "left"
}
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-copy" }, null, -1))
const _hoisted_64 = /*#__PURE__*/_createTextVNode(" Use all data")
const _hoisted_65 = [
  _hoisted_63,
  _hoisted_64
]
const _hoisted_66 = {
  key: 1,
  class: "right"
}
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-edit" }, null, -1))
const _hoisted_68 = /*#__PURE__*/_createTextVNode(" Assign Additional Fields")
const _hoisted_69 = [
  _hoisted_67,
  _hoisted_68
]
const _hoisted_70 = {
  key: 2,
  class: "left"
}
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-copy" }, null, -1))
const _hoisted_72 = /*#__PURE__*/_createTextVNode(" Use all data")
const _hoisted_73 = [
  _hoisted_71,
  _hoisted_72
]
const _hoisted_74 = {
  key: 3,
  class: "right"
}
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-upload" }, null, -1))
const _hoisted_76 = /*#__PURE__*/_createTextVNode(" Import additional data")
const _hoisted_77 = [
  _hoisted_75,
  _hoisted_76
]
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "far fa-caret-square-down pe-1" }),
  /*#__PURE__*/_createTextVNode(" IMPORT MLS DATA")
], -1))
const _hoisted_79 = [
  _hoisted_78
]
const _hoisted_80 = {
  key: 5,
  class: "column-message column-message-mls column-message-small"
}
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "This address wasn't in your MLS import.", -1))
const _hoisted_82 = [
  _hoisted_81
]
const _hoisted_83 = {
  key: 6,
  class: "left"
}
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-copy" }, null, -1))
const _hoisted_85 = /*#__PURE__*/_createTextVNode(" Use all data")
const _hoisted_86 = [
  _hoisted_84,
  _hoisted_85
]
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-copy" }, null, -1))
const _hoisted_88 = /*#__PURE__*/_createTextVNode(" Use all data")
const _hoisted_89 = [
  _hoisted_87,
  _hoisted_88
]
const _hoisted_90 = {
  key: 7,
  class: "right"
}
const _hoisted_91 = { class: "italic" }
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-unlock pe-1" }),
  /*#__PURE__*/_createTextVNode(" UNLOCK PEER DATA")
], -1))
const _hoisted_93 = [
  _hoisted_92
]
const _hoisted_94 = {
  key: 9,
  class: "left"
}
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-copy" }, null, -1))
const _hoisted_96 = /*#__PURE__*/_createTextVNode(" Use all data")
const _hoisted_97 = [
  _hoisted_95,
  _hoisted_96
]
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-copy" }, null, -1))
const _hoisted_99 = /*#__PURE__*/_createTextVNode(" Use all data")
const _hoisted_100 = [
  _hoisted_98,
  _hoisted_99
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isFieldData)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("button", {
                      id: "mapView",
                      class: "btn btn-light btn-sm button-width mb-1",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showMapView()))
                    }, _hoisted_8)
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("button", {
                      id: "photoView",
                      class: "btn btn-light btn-sm button-width position-relative",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.photoView()))
                    }, [
                      _hoisted_10,
                      _hoisted_11,
                      _createElementVNode("span", _hoisted_12, _toDisplayString(this.activePhotoCount), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("button", {
                      id: "dataFactSheet",
                      class: "btn btn-light btn-sm button-width",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showFactSheet()))
                    }, _hoisted_17)
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("button", {
                      id: "saleHistory",
                      class: "btn btn-light btn-sm button-width",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.saleHistory()))
                    }, _hoisted_21)
                  ])
                ])
              ])
            ])
          ])
        ]))
      : (_ctx.isTransferData)
        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _hoisted_25,
                _hoisted_26,
                _createElementVNode("div", _hoisted_27, [
                  (_ctx.isSubject)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                        _createElementVNode("i", {
                          class: _normalizeClass([_ctx.subjectCascadeIcon(this.subjectCascadeDisabled), "hover"]),
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.launchSubjectRunDataPreferencesModal())),
                          "data-toggle": "tooltip",
                          "data-original-title": "Data Preference disabled for Subject property. Click here to learn more."
                        }, null, 2)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _hoisted_29,
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.getFieldFillerCount()) + " fields filled out by QuickSource", 1)
            ])
          ]))
        : (_ctx.isCascadeData)
          ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
              _hoisted_33,
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("span", {
                  class: "right p-color-1 hover",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showDataSources()))
                }, "Data Source Legend")
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", {
              key: 3,
              class: _normalizeClass(["grid-table-cell noselect bg-color-1 grid-source-column", `header-${_ctx.cellData.initials}`])
            }, [
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("div", _hoisted_39, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["me-1", _ctx.getBadgeClass])
                      }, null, 2)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.cellData.name), 1),
                    (_ctx.isSubComp(_ctx.cellData))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_42, "#" + _toDisplayString(_ctx.cellData.subCompIdx), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_43, [
                    (_ctx.getSourceCountData(_ctx.cellData.initials, 'records') > 0 && _ctx.cellData.subCompIdx === null && (_ctx.cellData.initials === 'db' || (_ctx.cellData.initials === 'se' && _ctx.sEDetails.isOptedIn)))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                          _createElementVNode("div", _hoisted_45, [
                            (_ctx.getSourceCountData(_ctx.cellData.initials, 'records') > 1)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: "btn btn-dark btn-tiny sub-comp-button",
                                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.toggleSubCompData($event, _ctx.cellData.initials))),
                                  "is-collapsed": "true"
                                }, _hoisted_48))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              (_ctx.getSourceCountData(_ctx.cellData.initials, 'records') > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                    ((_ctx.cellData.initials === 'se' && _ctx.sEDetails.isOptedIn) || _ctx.cellData.initials === 'db')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                          (_ctx.cellData.subCompIdx === null)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_51, "Versions found: " + _toDisplayString(_ctx.getSourceCountData(_ctx.cellData.initials, 'records')), 1))
                            : _createCommentVNode("", true),
                          (_ctx.cellData.subCompIdx !== null)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_52, " "))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.cellData.initials === 'se' && _ctx.sEDetails.isOptedIn)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                          _createElementVNode("div", _hoisted_54, [
                            _createElementVNode("div", _hoisted_55, [
                              (_ctx.cellData.subCompIdx === null)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_56, "Yours: " + _toDisplayString(_ctx.getSourceCountData(_ctx.cellData.initials, 'yourCount')), 1))
                                : _createCommentVNode("", true),
                              (_ctx.cellData.subCompIdx === null)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_57, "Peers: " + _toDisplayString(_ctx.getSourceCountData(_ctx.cellData.initials, 'peerCount')), 1))
                                : (_openBlock(), _createElementBlock("div", _hoisted_58, " "))
                            ]),
                            _createElementVNode("div", _hoisted_59, [
                              _createElementVNode("div", _hoisted_60, "Used in " + _toDisplayString(_ctx.getSourceCountData(_ctx.cellData.initials, 'reportUseCount')) + " Report", 1)
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_61, [
                (_ctx.cellData.initials === 'pr')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                      _createElementVNode("span", {
                        class: "p-color-1 hover",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.useAllData(_ctx.cellData.initials)))
                      }, _hoisted_65)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.cellData.initials === 'pr')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                      _createElementVNode("span", {
                        class: "p-color-1 hover",
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showAdditionalFields()))
                      }, _hoisted_69)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.cellData.initials === 'mls' && !this.isSourceDataEmpty(_ctx.cellData.initials))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                      _createElementVNode("span", {
                        class: "p-color-1 hover",
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.useAllData(_ctx.cellData.initials)))
                      }, _hoisted_73)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.cellData.initials === 'mls' && this.isSourceDataEmpty(_ctx.cellData.initials))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                      _createElementVNode("span", {
                        class: "p-color-1 hover",
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.launchMLSImportModal()))
                      }, _hoisted_77)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.cellData.initials === 'mls' && !_ctx.hasMLSData && this.isSourceDataEmpty(_ctx.cellData.initials))
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 4,
                      class: "column-message column-message-mls mls-guide-reference hover",
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.launchMLSImportModal()))
                    }, _hoisted_79))
                  : _createCommentVNode("", true),
                (_ctx.cellData.initials === 'mls' && _ctx.hasMLSData && this.isSourceDataEmpty(_ctx.cellData.initials))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_80, _hoisted_82))
                  : _createCommentVNode("", true),
                (_ctx.cellData.initials === 'se' && !this.isSourceDataEmpty(_ctx.cellData.initials) && _ctx.sEDetails.isOptedIn)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                      (_ctx.cellData.subCompIdx === null)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: "p-color-1 hover",
                            onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.useAllData(_ctx.cellData.initials)))
                          }, _hoisted_86))
                        : (_openBlock(), _createElementBlock("span", {
                            key: 1,
                            class: "p-color-1 hover",
                            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.useAllSubCompData(_ctx.cellData.initials, _ctx.cellData.subCompIdx)))
                          }, _hoisted_89))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.cellData.initials === 'se' && _ctx.sEDetails.isOptedIn)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_90, [
                      _createElementVNode("span", _hoisted_91, _toDisplayString(_ctx.getWhoseComp(_ctx.cellData)), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.cellData.initials === 'se' && !_ctx.sEDetails.isOptedIn)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 8,
                      class: "column-message column-message-se hover",
                      onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.launchUnlockPeerDataModal()))
                    }, _hoisted_93))
                  : _createCommentVNode("", true),
                (_ctx.cellData.initials === 'db' && !this.isSourceDataEmpty(_ctx.cellData.initials))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_94, [
                      (_ctx.cellData.subCompIdx === null)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: "p-color-1 hover",
                            onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.useAllData(_ctx.cellData.initials)))
                          }, _hoisted_97))
                        : (_openBlock(), _createElementBlock("span", {
                            key: 1,
                            class: "p-color-1 hover",
                            onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.useAllSubCompData(_ctx.cellData.initials, _ctx.cellData.subCompIdx)))
                          }, _hoisted_100))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ], 2)),
    (_ctx.modalSubjectRunDataPreferences.show)
      ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.modalSubjectRunDataPreferences.component), {
          key: 4,
          onHide: _cache[17] || (_cache[17] = ($event: any) => (_ctx.modalSubjectRunDataPreferences.show = false))
        }))
      : _createCommentVNode("", true),
    (_ctx.modalConfirmation.show)
      ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.modalConfirmation.component), {
          key: 5,
          includeModalHeader: _ctx.modalConfirmation.titleShow,
          title: _ctx.modalConfirmation.title,
          message: _ctx.modalConfirmation.message,
          buttons: _ctx.modalConfirmation.buttons,
          modalSize: _ctx.modalConfirmation.size,
          onHide: _cache[18] || (_cache[18] = ($event: any) => (_ctx.modalConfirmation.show = false))
        }, null, 8, ["includeModalHeader", "title", "message", "buttons", "modalSize"]))
      : _createCommentVNode("", true)
  ], 64))
}